
import HashtagUp from "../../../assets/filled/HashtagUp.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HashtagUpIcon({ className, dataTestid = "HashtagUpIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <HashtagUp data-testid={dataTestid} className={classes} {...rest} />
  );
}
